module.exports = __webpack_public_path__ + "static/ModernEra-Bold-7f3f1e886c0ce42b308cdcac39ad7710.woff2";